import { useEffect, useState } from 'react'
import AOS from 'aos'
import SalesEnquiryForm from '@sections/SalesEnquiryForm'
import { SITE, CONTACT_FAQ,ROUTES  } from '@/constants'
import MetaInfo from '../components/common/MetaInfo'
import Breadcrumb from '@common/Breadcrumb'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.SALES_ENQUIRY)

export default function SalesEnquiry() {
  useEffect(() => { AOS.refresh(); window.scrollTo(0, 0) }, [])

  // Only one item open at a time; null = all closed
  const [openIdx, setOpenIdx] = useState(null)
  const toggle = idx => setOpenIdx(prev => (prev === idx ? null : idx))

  return (
    <>
      <MetaInfo
        title={`Talk To Sales | ${SITE.fullName}`}
        description="If you are looking for a quick quote from us, post your query here and we will get back to you!"
        keywords="React, Web Development, Mobile Apps, Business enquiry for software development, get quote for ecommerce portal, quote for mobile apps, software development company in thane, software company in mumbai, software company in india"
      />
     
      <main id="main-content" className="page-wrapper">
       {/* Hero */}
      <div className="page-hero page-hero-small" style={{boxShadow:'none'}}>
        <div
          className="bg-grid bg-grid--fill"
          aria-hidden="true"
        />

        <div className="container">
          
          <Breadcrumb />

          <h1 data-aos="fade-up" data-aos-delay={100}>
            Talk To Sales            
          </h1>

          <p className="page-subtitle page-subtitle-small" data-aos="fade-up" data-aos-delay={200}>
            Give our technology team a chance to bring your vision into reality. Just send us your details and let your success story begin.            
          </p>
        </div>
      </div>

        {/* ── Contact form ── */}
        <SalesEnquiryForm />

        {/* ── FAQ ── */}
        <section
          className="section-py contact-faq-section"
          aria-labelledby="contact-faq-heading"
        >
          <div className="container contact-faq-grid">

            {/* Left — heading */}
            <div className="contact-faq-left" data-aos="fade-right">
              {/* <span className="process-eyebrow">FAQ</span> */}
              <h2 id="contact-faq-heading" className="contact-faq-heading">
                Before you<br /> reach out
              </h2>
              <p className="contact-faq-sub">
                Quick answers to common questions about our services,
                process, and how we work with clients.
              </p>
            </div>

            {/* Right — accordion */}
            <div
              className="contact-faq-right"
              data-aos="fade-left"
            >
              <ul className="faq-list contact-faq-list" role="list">
                {CONTACT_FAQ.map((item, idx) => {
                  const isOpen = openIdx === idx
                  const itemId = `cfaq-${idx}`
                  const answerId = `cfaq-ans-${idx}`
                  return (
                    <li
                      key={idx}
                      className={`faq-item contact-faq-item${isOpen ? ' faq-open' : ''}`}
                    >
                      <button
                        id={itemId}
                        type="button"
                        className="faq-question"
                        onClick={() => toggle(idx)}
                        aria-expanded={isOpen}
                        aria-controls={answerId}
                      >
                        <span>{item.q}</span>
                        <span className="faq-icon" aria-hidden="true">
                          <i className={`fa-solid fa-chevron-${isOpen ? 'up' : 'down'}`} />
                        </span>
                      </button>

                      {isOpen && (
                        <div
                          id={answerId}
                          role="region"
                          aria-labelledby={itemId}
                          className="faq-answer"
                        >
                          <p>{item.a}</p>
                        </div>
                      )}
                    </li>
                  )
                })}
              </ul>
            </div>

          </div>
        </section>

      </main>
    </>
  )
}